export default "__VITE_PUBLIC_ASSET__cb61a49c__"